import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import { Auth } from '../../../autentication/Auth';

import { TransactionHandlerService } from '../../transfers-other-banks/transfer-response/services/transaction-handler.service';
import { TransactionReceiptModel } from '../../transfers-other-banks/transfer-response/models/trasanction-response.model';
import { TransactionResponseStatus } from '../../transfers-other-banks/transfer-response/models/transaction-response-status.enum';
import { Router } from '@angular/router';
import { Util } from '../../../utils/util';
import { TransferType } from '../../payment-securities/models/payment';
import { PaymentReceiptsService } from '../../payment-securities/services/payment-receipt.service';
import parseBarCode from '../../../parser/parseBarCode';
import { isAgreementCode } from '../../../validator/validateBarcode';

@Component({
  selector: 'app-receipt',
  templateUrl: './concluded-receipt.component.html',
  styleUrls: ['./concluded-receipt.component.styl'],
  encapsulation: ViewEncapsulation.None,
})
export class ConcludedReceiptComponent implements OnInit, OnDestroy {
	receipt: TransactionReceiptModel;
	title: string;
	transferSituation: TransactionResponseStatus;
	isPayment: boolean;
	digitableLine: string = "";

	get meuNome(): string{
		return Auth.getInstance().getUser().name ? Auth.getInstance().getUser().name : Util.camelCaseText(Auth.getInstance().getUser().loggedUserName);
	}

	get meuCpfCnpj(){
		return Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;
	}

	get minhaAgencia(){
		const user = Auth.getInstance().getUser()
		return Auth.getInstance().getUser().agency;
	}

	get minhaConta(): string{
		const minhaConta = Auth.getInstance().getUser().accountNumber.toString();
		return minhaConta.slice(0, minhaConta.length - 1) + '-' + minhaConta.slice(- 1);
	}

	get isScheduled(): boolean{
		return this.transferSituation === TransactionResponseStatus.AUTORIZADA_AGUARDANDO_EFETIVACAO || this.receipt.agendado;
	}

	get favoredBankName(): string {
		return this.receipt.nomeBancoDestino ? Util.camelCaseText(this.receipt.nomeBancoDestino) : '';
	}

	get favoredName(): string {
		return this.receipt.nomeFavorecido ? Util.camelCaseText(this.receipt.nomeFavorecido) : '';
	}

	get receiptTitle(): string {
    return this.receipt.agendado ? 'Comprovante de Agendamento' : this.isPayment ? 'Comprovante de pagamento' : 'Comprovante de transferência';
  }

	constructor(
		private router: Router,
		private paymentReceiptService: PaymentReceiptsService,
		private transactionHandlerService: TransactionHandlerService,
	) {
		this.transferSituation = this.transactionHandlerService.transferSituation;
		this.isPayment = this.paymentReceiptService.transferType === TransferType.BOLETO;
	}

	ngOnInit(): void {
		this.getReceipt();

		if(!isAgreementCode(this.receipt.codigoBarras)){
			this.digitableLine = this.receipt.codigoBarras;
			return;
		}
		
		this.digitableLine = parseBarCode(this.receipt.codigoBarras).code;
	}

	ngOnDestroy(): void {
		this.receipt = new TransactionReceiptModel();
		this.transactionHandlerService.clearReceiptModel();
		this.transactionHandlerService.clearTransferSituation();
		this.paymentReceiptService.clearPaymentReceipt();
		this.isPayment = false;
	}

	getReceipt() {
			if (this.transferSituation === TransactionResponseStatus.TRANSFERENCIA_REALIZADA && !this.isPayment) {
				this.receipt = this.transactionHandlerService.getReceiptModel();
			} else if (this.isPayment) {
				this.receipt = this.paymentReceiptService.getReceiptModel();
			} else {
				this.receipt = this.transactionHandlerService.getScheduledReceiptModel();
			}

		setTimeout(() => this.emitPrint(), 200);

			if (!this.receipt) {
				this.goBack();
			}
	}

	goBack() {
		this.receipt = new TransactionReceiptModel();
		this.router.navigate(['comprovantes/']);
	}

	emitPrint() {
		window.print();
	}

	getCpfCnpj(cpfCnpj: string) {
		if (!cpfCnpj) {
			return;
		}

		return Util.maskCpfCnpjPix(cpfCnpj);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/receipts/concluded-receipt/concluded-receipt.component.ts